import { AccompanyOnDepartureInformation } from './accompany-on-departureInformation';
import { GuardianInformation } from './guardian-information';
import { MeetingOnArrivalInformation } from './meeting-on-arrival-information';

/**
 * 登録済みジュニアパイロット情報(搭乗者ID)
 */
export interface RegisteredJuniorPilotTravelerIdInner {
  /** 申込状況 */
  serviceStatus?: RegisteredJuniorPilotServiceStatus.ServiceStatusEnum;

  /** 見送り人情報 */
  accompanyOnDepartureInformation?: AccompanyOnDepartureInformation;

  /** 出迎え人情報 */
  meetingOnArrivalInformation?: MeetingOnArrivalInformation;

  /** 保護者情報 */
  guardianInformation?: GuardianInformation;

  /** 見送り人情報のOSIのID	*/
  osiIdOfAccompany?: string;

  /** 出迎え人情報のOSIのID	*/
  osiIdOfMeeting?: string;

  /** 小児が話す言語情報のOSIのID	*/
  osiIdOfLanguage?: string;

  /** 当該搭乗者にリレートするSSR UMNRのID	*/
  umnrId?: string;

  /** 当該搭乗者にリレートするSK OKBPのID	*/
  okbpId?: string;
}

export namespace RegisteredJuniorPilotServiceStatus {
  export type ServiceStatusEnum = 'requested' | 'notRequested' | 'unnecessary';
  export const ServiceStatusEnum = {
    Requested: 'requested' as ServiceStatusEnum,
    NotRequested: 'notRequested' as ServiceStatusEnum,
    Unnecessary: 'unnecessary' as ServiceStatusEnum,
  };
}
